const endcapData = {
  fillArrow: {
    start: {
      viewBox: "-2 -2 20 20",
      refX: 1,
      refY: 10,
      markerWidth: 10,
      markerHeight: 20,
      path: "M 10 0 L 0 10 L 10 20 Z 10 0",
      fill: "black",
      stroke: "black"
    },
    end: {
      viewBox: "-2 -2 20 20",
      refX: 9,
      refY: 10,
      markerWidth: 10,
      markerHeight: 20,
      path: "M 0 0 L 10 10 L 0 20 Z 0 0",
      fill: "black",
      stroke: "black"
    }
  },
  largeFillArrow: {
    start: {
      viewBox: "-2 -2 40 24",
      refX: 1,
      refY: 10,
      markerWidth: 20,
      markerHeight: 20,
      path: "M 20 0 L 0 10 L 20 20 Z 20 0",
      fill: "black",
      stroke: "black"
    },
    end: {
      viewBox: "-2 -2 40 24",
      refX: 20,
      refY: 10,
      markerWidth: 20,
      markerHeight: 20,
      path: "M 0 0 L 20 10 L 0 20 Z 0 0",
      fill: "black",
      stroke: "black"
    }
  },
  lineArrow: {
    start: {
      viewBox: "-2 -2 20 20",
      refX: 1,
      refY: 10,
      markerWidth: 10,
      markerHeight: 20,
      path: "M 10 0 L 0 10 L 10 20",
      fill: "none",
      stroke: "black"
    },
    end: {
      viewBox: "-2 -2 20 20",
      refX: 9,
      refY: 10,
      markerWidth: 10,
      markerHeight: 20,
      path: "M 0 0 L 10 10 L 0 20",
      fill: "none",
      stroke: "black"
    }
  },
  largeLineArrow: {
    start: {
      viewBox: "-2 -2 40 24",
      refX: 1,
      refY: 10,
      markerWidth: 20,
      markerHeight: 20,
      path: "M 20 0 L 0 10 L 20 20",
      fill: "none",
      stroke: "black"
    },
    end: {
      viewBox: "-2 -2 40 24",
      refX: 20,
      refY: 10,
      markerWidth: 20,
      markerHeight: 20,
      path: "M 0 0 L 20 10 L 0 20",
      fill: "none",
      stroke: "black"
    }
  },
  flat: {
    start: {
      viewBox: "-2 -2 4 20",
      refX: 0,
      refY: 10,
      markerWidth: 2,
      markerHeight: 20,
      path: "M 0 0 L 0 20",
      fill: "none",
      stroke: "black"
    },
    end: {
      viewBox: "-2 -2 4 20",
      refX: 0,
      refY: 10,
      markerWidth: 2,
      markerHeight: 20,
      path: "M 0 0 L 0 20",
      fill: "none",
      stroke: "black"
    }
  }
};

export default endcapData;
